import {toURL} from '@homeaway/search-url-parser';
import {seoDestinationName} from './seo-url-builder';

export const getPrefix = () => window.location.pathname.split('/')[1] || 'd';

export function buildSerpUrl({host, params}) {

    if (params && typeof params.q === 'string') {
        params.q = seoDestinationName(params.q);
    }

    return toURL(params, {hostname: host});
}
